import { Component } from '@angular/core';
import { GlobalAdjustments } from '../models/global-adjustments.model';
import { GlobalSettings } from '../models/global-settings.model';
import { GlobalSettingsService } from '../services/global-settings.service';

@Component({
    templateUrl: './settings-adjustments.component.html',
    styleUrls: [ './settings-adjustments.component.scss' ]
})

export class AdjustmentSettingsComponent {
    settings: GlobalSettings;
    adjustments: GlobalAdjustments;

    valueTypes = [
        {value: 0, name: '£'},
        {value: 1, name: '%'}
    ];

    constructor(private settingsService: GlobalSettingsService) {
        this.settingsService.onGlobalSettingsUpdated.subscribe(
            (response) => {
                this.settings = response;
                this.adjustments = this.settings.adjustments;
            },
            (error) => {
                console.log(error);
            }
        );

        this.settingsService.getGlobalAdjustments();
    }
    updateGlobalAdjustments(field: string) {
        this.settingsService.recordChangedField(field);
        this.settingsService.updateGlobalAdjustments(this.settings);
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/components/settings-adjustments.component.ts